import { useMemo } from "react";

import CircularProgress from "ds/components/CircularProgress";
import type { CircularProgressState } from "ds/components/CircularProgress/types";

type UserGuideGroupStatusIndicatorProps = {
  isCompleted: boolean;
  isInProgress: boolean;
  currentStep?: number;
  totalSteps: number;
};

const UserGuideGroupStatusIndicator = ({
  isCompleted,
  isInProgress,
  currentStep,
  totalSteps,
}: UserGuideGroupStatusIndicatorProps) => {
  const state: CircularProgressState = useMemo(() => {
    if (isCompleted) return "completed";
    if (isInProgress) return "in-progress";
    return "not-started";
  }, [isCompleted, isInProgress]);

  const progress = useMemo(() => {
    if (!isInProgress) return 0;
    if (!currentStep) return 0;
    if (totalSteps <= 0) return 0;
    return (currentStep / totalSteps) * 100;
  }, [isInProgress, currentStep, totalSteps]);

  const ariaLabel = useMemo(() => {
    if (isCompleted) return "Guide completed";
    if (isInProgress) return "Guide in progress";
    return "Guide not started";
  }, [isCompleted, isInProgress]);

  return <CircularProgress state={state} progress={progress} ariaLabel={ariaLabel} />;
};

export default UserGuideGroupStatusIndicator;
